import React from 'react';
import { TextAa, Paragraph, CaretCircleDown, Envelope, PencilSimple, Trash } from '@phosphor-icons/react';
import { Checkbox, Radio } from 'app/components';

const FORM_DROPDOWN = [
  {
    icon: <TextAa />,
    id: 'Short Text',
    label: 'Short Text',
  },
  {
    icon: <Paragraph />,
    iconProps: {
      weight: 'fill',
    },
    id: 'Paragraph text',
    label: 'Paragraph text',
  },
  {
    icon: <Checkbox checked />,
    id: 'Multiple choice',
    label: 'Multiple choice',
  },
  {
    icon: <Radio checked />,
    id: 'Single choice',
    label: 'Single choice',
  },
  {
    icon: <CaretCircleDown />,
    iconProps: {
      weight: 'fill',
    },
    id: 'Dropdown',
    label: 'Dropdown',
  },
  {
    icon: <Envelope />,
    iconProps: {
      weight: 'fill',
    },
    id: 'Email',
    label: 'Email',
  },
];

const OPTION_TYPES = [
  'Multiple choice',
  'Single choice',
  'Dropdown',
];

const SUB_QUESTION_ALLOWED_TYPES = [
  'Multiple choice',
  'Single choice',
  'Dropdown',
];

const EMAIL_TYPE = 'Email';

const MULTIPLE_CHOICE_TYPE = 'Multiple choice';

const ACTION_ITEMS = [
  {
    id: 'edit',
    icon: <PencilSimple />,
  },
  {
    id: 'delete',
    icon: <Trash />,
  },
];

const NON_OPTION_CONFIGS = ['Short Text', 'Paragraph text'];

export {
  FORM_DROPDOWN,
  OPTION_TYPES,
  SUB_QUESTION_ALLOWED_TYPES,
  ACTION_ITEMS,
  EMAIL_TYPE,
  MULTIPLE_CHOICE_TYPE,
  NON_OPTION_CONFIGS,
};